import _ from 'lodash'

export const DATA_OBJECT_CHANGE_PROPS = ['data', 'name', 'title']
export const DATA_OBJECT_PROPS = DATA_OBJECT_CHANGE_PROPS.concat(['id', 'type', 'schema_ref', 'model_id', 'is_virtual'])
export const PAGING_FIELDS = ['id', 'name', 'title', 'type', 'layout']

export const STATUS_MAP = {
  'added': 'success',
  'removed': 'danger',
  'changed': 'info'
}

export const MODEL_MAP = {
  'project': {
    url: `/projects`,
    model: 'App.Models.Project'
  },
  'learning': {
    url: `/learning`,
    model: 'App.Models.LearningObject'
  },
  'driver': {
    url: '/projects',
    model: 'App.Models.Driver'
  },
  'publication': {
    url: '/publications',
    model: 'App.Models.Publication'
  }
}

export const cloneDataObject = (obj, omit) => {
  const cloned = _.pick(obj, DATA_OBJECT_PROPS)
  return _.omit({
    ...cloned,
    data: _.cloneDeep(obj.data)
  }, omit)
}

export const getInteraction = (page) => {
  if (!page) {
    return null
  }

  const parts = _.split(page.type, '/')
  const value = { type: parts[0] }
  if (parts[1]) {
    value.layout = parts[1]
  }
  return value
}

export const getInteractionId = (interaction) => {
  return interaction.layout ? `${interaction.type}/${interaction.layout}` : interaction.type
}

export const getInteractionName = (interactions, page) => {
  const interactionParts = getInteraction(page)
  const interaction = _.find(interactions, interactionParts)
  return interaction?.name ?? page?.type ?? null
}

export const getCleanTitle = (object) => {
  const title = object.title || object.name
  return _.startCase(title.replace('_', ''))
}

export const difference = (object, base) => {
  return _.transform(object, (result, value, key) => {
    if (!_.isEqual(value, base[key])) {
      result[key] = (_.isObject(value) && _.isObject(base[key])) ? difference(value, base[key]) : value
    }
  })
}

export const isEqual = (source, compare) => {
  return _.isEqualWith(source, compare, (obj, other) => {
    // allow empty strings to be same as null
    if ((obj === '' || obj === null) && (other === '' || other === null)) {
      // console.log('string equals null')
      return true
    }
  })
}

export const isMergeable = (source, current) => {
  const originalData = source?.prevRevision.data || { }
  const incomingData = source.data || { }
  const currentData = current.data || { }

  const incomingDelta = getDeltaMap(originalData, incomingData)
  const currentDelta = getDeltaMap(originalData, currentData)

  // console.log(incomingDelta, currentDelta)
  
  const resultA = applyDeltas(originalData, [incomingDelta, currentDelta])
  const resultB = applyDeltas(originalData, [currentDelta, incomingDelta])

  // console.log(resultA, resultB)

  // compare the results, if identical, changes can be merged
  // return JSON.stringify(resultA) === JSON.stringify(resultB)
  return isEqual(resultA, resultB)
}

export const applyDeltas = (source, deltas = []) => {
  const result = _.cloneDeep(source)
  deltas.forEach((changes) => {
    for (let key in changes) {
      _.set(result, key, changes[key])
    }
  })
  return result
}

export const getDeltaMap = (source, current) => {
  // calculate delta as dot-notation hashmap
  const sourceMap = dotMap(source)
  const currentMap = dotMap(current)
  return difference(currentMap, sourceMap)
}

export const dotMap = (object) => {
  const result = { }

  function flatten(obj, prefix = '') {
    _.forEach(obj, (value, key) => {
      if (_.isObject(value)) {
        flatten(value, `${prefix}${key}.`)
      } else {
        result[`${prefix}${key}`] = value
      }
    })
  }

  flatten(object)

  return result
}
